<script lang="ts">
import { defineComponent } from 'vue'
import { mapState } from 'vuex'

export default defineComponent({
  name: 'FloatingPrintButton',

  computed: {
    ...mapState('event', ['eventAllContent']),

    showButton (): boolean {
      return !!(this as any).eventAllContent?.event_settings?.enable_quick_print_badge_button
    }
  }
})
</script>

<template>
  <div v-if="showButton">
    <gtr-badge-search-and-print v-slot="{ attrs, on }">
      <v-btn
        fab
        dark
        fixed
        top
        right
        class="floating-print-button"
        color="var(--a2z-accent)"
        v-bind="attrs"
        v-on="on"
      >
        <v-icon>mdi-printer-outline</v-icon>
      </v-btn>
    </gtr-badge-search-and-print>
    <!-- xs only: room at the end of the page so the fixed button never covers the last row or pagination -->
    <div class="floating-print-button-spacer d-sm-none"></div>
  </div>
</template>

<style scoped>
.floating-print-button.v-btn--fab {
  width: 50px !important;
  height: 50px !important;
  /* Push below the app bar (legacy header: 100px, FUI header: 56px).
     Vuetify fixed-top FABs default to 16px from the viewport top, which
     collides with any app bar.  116px clears both header variants. */
  top: 116px !important;
}

/* Matches $vuetify.breakpoint.xs. On small screens the top-right spot lands on
   the event name strip and table rows, so anchor to the bottom instead. Bottom-LEFT, because
   the Forethought remote support widget (third-party, fixed) owns the bottom-right corner
   and its launcher size is outside our control. */
@media (max-width: 599px) {
  .floating-print-button.v-btn--fab {
    top: auto !important;
    bottom: 16px !important;
    right: auto !important;
    left: 16px !important;
  }
}

/* 50px button + 16px offset + 16px breathing room */
.floating-print-button-spacer {
  height: 82px;
}
</style>
